import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Map = ({ onLoad, ...props }) => {
  useEffect(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1066"
    >
      <polygon
        data-floor="0"
        points="326 712 407 725 407 746.34 499 762 530 752 534 752 534 761 638 778 659 770 659 776 661 776 661 784 774 802 796 794 796 799.82 800 800 800 807.76 928 830 956 816 956 822.96 960 823 960 830 1113 856 1136 840 1136 833.78 1241 850 1252 841 1312 850 1354 809 1354 795.41 1384 799 1384 805.8 1239 932 985 885 977 890 569 808 553 814 328 768 326 712"
      />

      <polygon
        data-floor="1"
        points="326 712 407 725 407 746.34 499 762 530 752 534 752 534 761 638 778 659 770 659 776 661 776 661 784 774 802 796 794 796 799.82 800 800 800 807.76 928 830 956 816 956 822.96 960 823 960 830 1113 856 1136 840 1136 833.78 1241 850 1252 841 1312 850 1354 809 1354 795.41 1384 799 1391 799 1433 754 1433 718.83 1403 715 1392 725 1354 723 1353 740 1312 771 1255 764 1243 771 1133 759 1113 769 960 749.05 960 737.93 955 738 929 749 800 732 800 720 795 720 777 726 660 711 660 699 639 705 532 692 532 684 496 693 408 681 408 668 324 657 324 676.5 320 676 320 707 326 707 326 712"
      />

      <polygon
        data-floor="2"
        points="324 657 408 668 408 681 496 693 532 684 532 692 639 705 660 699 660 711 777 726 795 720 800 720 800 732 929 749 955 738 960 737.93 960 749.05 1113 769 1133 759 1243 771 1255 764 1312 771 1353 740 1354 723 1392 725 1403 715 1434 687 1434 651 1397 649 1397 646 1392 648 1356 647 1356 661 1315 684 1256 678 1245 684 1136 675 1114 683 961 668 961 658 955 659 928 668 800 654 800 642 772 649 656 640 656 630 634 635 530 624 530 617 495 625 405 615 405 609 411.12 609 412 606 321 598 321 617.17 316 617 316 643.56 324 644 324 657"
      />

      <polygon
        data-floor="3"
        points="321 598 356.46 601.12 412 606 411.12 609 405 609 405 615 495 625 530 617 530 624 634 635 656 630 656 640 772 649 800 642 800 654 928 668 955 659 961 658 961 668 1114 683 1136 675 1245 684 1256 678 1315 684 1356 661 1356 647 1392 648 1397 646 1435 620 1435 583.33 1399 582 1399 570 1393 572 1358 572 1358 581 1317 597 1258 593 1246 595 1136 590 1114 596 960 585.47 960 575.63 955 576 928 585 799 576 799 569 793.4 569 769 573 528 554 528 551 492 554 403 550 403 542 319 536 319 559.58 313 559.58 313 585 321 585 321 598"
      />

      <polygon
        data-floor="4"
        points="319 536 403 542 403 550 492 554 528 551 528 554 769 573 793.4 569 799 569 799 576 928 585 955 576 960 575.63 960 585.47 1114 596 1136 590 1246 595 1258 593 1317 597 1358 581 1358 572 1393 572 1399 570 1438 551 1438 514.83 1400 514 1400 494 1359.7 494 1360 500 1319 508 1260 507 1249 508 1134 505 1117 509 962 502 962 497 956 497 928 501 798 497 798 495 769 496 526 486 526 483 489 485 399.78 483 400 476 315 474 316 501 312 501 312 533 319.02 533 319 536"
      />

      <polygon
        data-floor="5"
        points="315 474 400 476 399.78 483 489 485 526 483 526 486 769 496 798 495 798 497 928 501 956 497 962 497 962 502 1117 509 1134 505 1249 508 1260 507 1319 508 1360 500 1359.7 494 1400 494 1440 484 1440 445.41 1402.67 445.41 1403 416 1361.55 416 1361 418 1321 419 1263 419 1250 420 1139 419 1117 419 961 418 961 417 954 417 927 417 797 417 768 417 524.3 416 524 414 487.94 414 313 414 314 441 311 441 312 472.1 315 472 315 474"
      />

      <polygon
        data-floor="6"
        points="313 414 453.17 414 487.94 414 524 414 524.3 416 604.83 416.33 640.98 416.33 710.58 416.76 768 417 797 417 929.57 417 961 417 961 418 1049.6 418.57 1115.2 418.99 1127.31 419 1153.92 419 1192.41 419.48 1250 420 1263 419 1302.08 419 1321 419 1361 418 1361.55 416 1403 416 1442 415 1442 376.74 1404.64 376.74 1405 347 1462.35 347 1402 337 1375.87 337 1289 325 1034 330 929 334 533 344 480 344 394 346 311 346.77 312 379.5 305 380 305 405.52 313 405 313 414"
      />

      <polygon
        data-floor="7"
        points="311 346.77 394 346 486.07 344 528.19 344 621.03 341.78 774.04 337.91 863.57 335.65 929 334 962.24 332.73 1047.01 329.75 1289 325 1375.87 337 1402 337 1462.35 347 1462.35 337.48 1456 337 1456 310 1407 296 1407 281 1455 280 1455 240 1426 227 1426 224 1466 223 1466 212.77 1408 178 1382.95 178 1293 130 1034 155 1032 220 952 202 952 196 951 196 951 174 952 174 952 172 938 168 901 170 901 189 857 179 808 180 808 184 776 186 776 184 736 187 736 190 586 202 586 252 567 252 536 250 306 265 307 320 303 320 303 345.85 311 346 311 346.77"
      />
    </svg>
  );
};

Map.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

export default Map;
